import React, { useRef } from 'react';
import {
  ContentContainer,
  DashboardContainer,
  MetricsGrid,
  MetricCard,
  MetricValue,
  MetricLabel,
} from './analytics.style';
import { useNavigate } from 'react-router-dom';
import { AdminAnalyticsPie } from '../../../components/chart';

// Reusable Metric Tile Component
const MetricTile = ({ value, label, id, detailsView }) => (
  <MetricCard role="article" aria-labelledby={`${id}-label`} tabIndex="0" onClick={detailsView}>
    <MetricValue aria-describedby={`${id}-label`}>{value.toLocaleString()}</MetricValue>
    <MetricLabel id={`${id}-label`}>{label}</MetricLabel>
  </MetricCard>
);

const AnalyticsDashboard = () => {
  const mapRef = useRef(null);
  const navigate = useNavigate();

  const metricsData = [
    { id: 'total-enquires', value: 890, label: 'Total Enquires' },
    { id: 'pre-lodge-report', value: 230, label: 'Pre lodge Report' },
    { id: 'final-report', value: 100, label: 'Final Report' },
    { id: 'cancel-da', value: 128, label: 'Cancel DA' },
    { id: 'reviewing', value: 450, label: 'Reviewing' },
  ];

  const handleDeatailsView = () => {
    navigate('/analyticsDetails');
  };

  return (
    <DashboardContainer>
      <ContentContainer id="main-content">
        <section aria-labelledby="metrics-title">
          <h2 id="metrics-title" className="sr-only">
            Key Metrics
          </h2>
          <MetricsGrid role="group" aria-label="Key performance metrics">
            {metricsData.map((metric) => (
              <MetricTile
                key={metric.id}
                id={metric.id}
                value={metric.value}
                label={metric.label}
                detailsView={handleDeatailsView}
              />
            ))}
          </MetricsGrid>
        </section>
        <AdminAnalyticsPie />
      </ContentContainer>

      {/* Hidden styles for screen readers */}
      <style jsx>{`
        .sr-only {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        }
      `}</style>
    </DashboardContainer>
  );
};

export default AnalyticsDashboard;
